/** Approval scheme types */
export enum ApprovalSchemeTypeEnum {
  /** Sequential - one participant in the scheme can approve strictly after another */
  SEQUENTIAL = 'SEQUENTIAL',
  /** Parallel - participants in the scheme can approve in any order */
  PARALLEL = 'PARALLEL',
}
